import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-system/param/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}
export const remove = (ids, tenantId) => {
  return request({
    url: '/api/blade-system/param/remove?tenantId=' + tenantId,
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-system/param/submit?tenantId=' + row.tenantId,
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-system/param/submit?tenantId=' + row.tenantId,
    method: 'post',
    data: row
  })
}
